import {
  Component
} from "react";
import fetchCandidateResume from '../../../lib/Candidate/fetchCandidateResume.async';
import {
  trim
} from '../../../lib/String.lib';
import Box from '../../Layout/Wrappers/Box';
import JobHeader from './JobHeader';
import Requirements from "./Requirements";
import RequirementsSection3 from "./RequirementsSection3";
import SubmissionHistory from "./SubmissionHistory";

class JobPipe extends Component {

  constructor() {
    super(...arguments);
    this.state = {
      candidateResume: null
    }
  }

  componentDidMount() {
    const resumeTxtUrl = this.props.candidate?.resumeTxtUrl;
    this.fetchResume(resumeTxtUrl);
  }

  componentDidUpdate(prevProps) {
    const resumeTxtUrl = this.props.candidate?.resumeTxtUrl;
    if (
      prevProps.candidate?.resumeTxtUrl !== resumeTxtUrl
    ) {
      this.fetchResume(resumeTxtUrl);
    }
  }

  fetchResume = (resumeTxtUrl) => !!trim(resumeTxtUrl) && (
    fetchCandidateResume({
      url: resumeTxtUrl,
      source: 'JobPipe__fetchResume',
    }).then((candidateResume) => this.setState({
      candidateResume
    }))
  );

  render() {
    const {
      candidate = {},
      job = {}
    } = this.props;
    const {
      saveJob,
      source,
    } = this.props;
    const {
      candidateResume
    } = this.state;
    return (
      <>

        {!!job.id &&
          <Box column w100>

            <Box className='sticky-top bg-main border-bottom'>
              <JobHeader
                candidate={candidate}
                job={job}
              />
            </Box>

            <Box column w100 className='px-05'>

              {!!candidate.id &&
                <Requirements
                  candidate={candidate}
                  job={job}
                  saveJob={saveJob}
                  candidateResume={candidateResume}
                  source={source}
                />
              }

              {/** [2024-08-28][story_11099] @note RequirementsSection2 was removed */}

              {!!candidate.id &&
                <RequirementsSection3
                  candidate={candidate}
                  job={job}
                />
              }

              <SubmissionHistory job={job} />

            </Box>

          </Box>
        }

      </>
    )
  }
}

export default JobPipe;